import { FeedReactionKindsEnum, LikeEmojiEnum, NotificationTypesEnum } from '../enums';

export function getEmojiForReactionKind(kind: FeedReactionKindsEnum): LikeEmojiEnum | null {
	switch (kind) {
		case FeedReactionKindsEnum.CommentLike:
			return LikeEmojiEnum.Clap; // IF NEEDED: change to thumbs up
		case FeedReactionKindsEnum.ClapActivity:
			return LikeEmojiEnum.Clap;
		case FeedReactionKindsEnum.HeartActivity:
			return LikeEmojiEnum.Heart;
		case FeedReactionKindsEnum.MuscleActivity:
			return LikeEmojiEnum.Muscle;
		default:
			return null;
	}
}
export function getNotificationTypeForReactionKind(
	kind: FeedReactionKindsEnum,
	isActivityAuthor = false,
	isCommentAuthor = false
): NotificationTypesEnum | null {
	switch (kind) {
		case FeedReactionKindsEnum.CommentLike:
			return NotificationTypesEnum.NewLikeOnYourComment;
		case FeedReactionKindsEnum.ClapActivity:
			return NotificationTypesEnum.NewReactionToYourPost;
		case FeedReactionKindsEnum.HeartActivity:
			return NotificationTypesEnum.NewReactionToYourPost;
		case FeedReactionKindsEnum.MuscleActivity:
			return NotificationTypesEnum.NewReactionToYourPost;
		case FeedReactionKindsEnum.Reply:
			return isActivityAuthor
				? NotificationTypesEnum.NewCommentOnYourPost
				: isCommentAuthor
				? NotificationTypesEnum.NewReplyToYourComment
				: NotificationTypesEnum.NewCommentNearYourComment;
		case FeedReactionKindsEnum.ReplyLike:
			return NotificationTypesEnum.NewLikeOnYourReply;
		case FeedReactionKindsEnum.Comment:
			return isActivityAuthor
				? NotificationTypesEnum.NewCommentOnYourPost
				: NotificationTypesEnum.NewCommentNearYourComment;
		default:
			return null;
	}
}
